import { Box, SxProps, Theme } from "@mui/material";
import { DotLegalLink, ToDto } from "@dotlegal/dotlegal-ui-components";
import { EntityType } from "@common/Common.types";
import { getEntityTypeIcon } from "./entityTypeIcon";

// Single source of truth for rendering an entity type icon next to a label (the entity name or the type
// label). Keeps the icon size consistent everywhere — previously each call site styled the svg itself, so
// the sizing drifted across the risk overviews.
const baseStyle = {
    display: "flex",
    alignItems: "center",
    gap: 1,
    // The icons carry no width/height attributes of their own, so 16px is only a flex basis: without flexShrink a
    // constrained row (a long name wrapping to two lines) squeezes the svg and preserveAspectRatio shrinks the drawing.
    "& svg": {
        width: 16,
        height: 16,
        flexShrink: 0,
        fill: "#DAD9EF",
    },
};

interface EntityTypeIconWithNameProps {
    type: EntityType;
    name: string;
    // Renders the name as a link to this destination. A URL-shaped prop rather than a caller-supplied node, so the
    // component keeps deciding how icon and label look together.
    linkTo?: ToDto | string;
    tooltip?: string;
    sx?: SxProps<Theme>;
}

function EntityTypeIconWithName({ type, name, linkTo, tooltip, sx }: EntityTypeIconWithNameProps) {
    return (
        <Box sx={[baseStyle, ...(Array.isArray(sx) ? sx : [sx])]} title={tooltip}>
            {getEntityTypeIcon(type)}
            {linkTo ? (
                <DotLegalLink to={linkTo} linkColor="primary" bold stopPropagation>
                    {name}
                </DotLegalLink>
            ) : (
                name
            )}
        </Box>
    );
}

export default EntityTypeIconWithName;
